import {lightenButtonInteractions, darkenButtonInteractions} from '/misc_functions/button_color_changes.js';
import {GREY_BUTTON_COLOR, RED_BUTTON_COLOR, ROYAL_BLUE_COLOR} from '/constants/colors.js';
import {API_GATEWAY} from '/constants/API_constants.js';

const mode = {
    'post-like' : {
        background : GREY_BUTTON_COLOR,
        color : 'black',
        innerText : 'Like',
        eventFunction : postLike,
        backgroundColorInteractions : darkenButtonInteractions
    },
    'post-dislike' : {
        background : GREY_BUTTON_COLOR,
        color : 'black',
        innerText : 'Dislike',
        eventFunction : postDislike,
        backgroundColorInteractions : darkenButtonInteractions
    },
    'delete-like' : {
        background : ROYAL_BLUE_COLOR,
        color : 'white',
        innerText : 'Liked',
        eventFunction : deleteLike,
        backgroundColorInteractions : lightenButtonInteractions
    },
    'delete-dislike' : {
        background : RED_BUTTON_COLOR,
        color : 'white',
        innerText : 'Disliked',
        eventFunction : deleteDislike,
        backgroundColorInteractions : lightenButtonInteractions
    }
}

export function makeElementLikeButton(nodeId, element, modeValue) {
    const modeObject = mode[modeValue];

    const newElement = element.cloneNode(true);

    newElement.style.background = modeObject.background;
    newElement.style.color = modeObject.color;
    newElement.innerText = modeObject.innerText;
    
    newElement.addEventListener('click', () => modeObject.eventFunction(nodeId, newElement));
    
    element.replaceWith(newElement);

    modeObject.backgroundColorInteractions(newElement);
}

async function postLike(nodeId, element) {
    const response = await fetch(API_GATEWAY + "likes/post/like/" + nodeId, {
        method: "POST",
        headers: {
            "Token-Auth": `${localStorage.branchof_access_token}`
        }
    })

    if(response.status===200) {
        switchAnotherButton(nodeId, element, 'post-dislike');
        makeElementLikeButton(nodeId, element, 'delete-like');
    }
}

async function postDislike(nodeId, element) {
    const response = await fetch(API_GATEWAY + "likes/post/dislike/" + nodeId, {
        method: "POST",
        headers: {
            "Token-Auth": `${localStorage.branchof_access_token}`
        }
    })

    if(response.status===200) {
        switchAnotherButton(nodeId, element, 'post-like');
        makeElementLikeButton(nodeId, element, 'delete-dislike');
    }
}

async function deleteLike(nodeId, element) {
    const response = await fetch(API_GATEWAY + "likes/delete/" + nodeId, {
        method: "DELETE",
        headers: {
            "Token-Auth": `${localStorage.branchof_access_token}`
        }
    })

    if(response.status===200) {
        makeElementLikeButton(nodeId, element, 'post-like');
    }

}

async function deleteDislike(nodeId, element) {
    const response = await fetch(API_GATEWAY + "likes/delete/" + nodeId, {
        method: "DELETE",
        headers: {
            "Token-Auth": `${localStorage.branchof_access_token}`
        }
    })

    if(response.status===200) {
        makeElementLikeButton(nodeId, element, 'post-dislike');
    }

}

function switchAnotherButton(nodeId, element, modeValue) {
    const otherElements = element.parentNode.children;

    for(let anotherElement of otherElements) {
        if(anotherElement!==element) {
            makeElementLikeButton(nodeId, anotherElement, modeValue);
        }
    }
}